const texto = (valor) => typeof valor === "string" ? valor.trim() : "";

// El nombre pertenece al renglón, aunque varios pedidos compartan la misma MP.
// Sin snapshot se usa el nombre base: el nombre comercial puede ser de otro pedido.
export const nombreCompraDetalle = (detalle, materiaPrima = detalle?.materiaPrima) =>
  texto(detalle?.nombreCompra) ||
  texto(materiaPrima?.nombre) || texto(detalle?.nombreServicio) || "Sin nombre";

export const unidadCompraDetalle = (detalle, materiaPrima = detalle?.materiaPrima, abreviada = false) =>
  (detalle?.requierePack ? texto(detalle?.unidadPack) : "") ||
  (abreviada
    ? texto(detalle?.unidadAbreviatura) || texto(detalle?.unidadNombre)
    : texto(detalle?.unidadNombre) || texto(detalle?.unidadAbreviatura)) ||
  (abreviada
    ? texto(materiaPrima?.tipoUnidad?.abreviatura) || texto(materiaPrima?.tipoUnidad?.nombre)
    : texto(materiaPrima?.tipoUnidad?.nombre) || texto(materiaPrima?.tipoUnidad?.abreviatura)) || "-";
